import React, {Component} from 'react';
import './Message.css'

class Message extends Component {
    constructor(props) {
      super(props);
      this.state={
        chatOpen: false
      }
    }

    onChatOpen=()=>{
        if(this.state.chatOpen){
            this.setState({
                chatOpen: false
            })
        }else{
            this.setState({
                chatOpen: true
            })
        }
    }

    render() {
        return(
            <div className="messageComponent">
                <div className="button">
                   <span onClick={this.onChatOpen}><i className={this.state.chatOpen ? "fa fa-times" : "fa fa-envelope"}></i></span>
                   {this.state.chatOpen && <div className="chat">
                        <div className="header">
                            <h5>Support Message</h5>
                            <p>Please fill out the form below and we will get back to you as soon as possible</p>
                        </div>
                        <div className="formContent">
                            <div className="form">
                                <div className="form-group">
                                    <small>Title</small>
                                    <input type="text" className="form-control"/>
                                </div>
                                <div className="form-group">
                                    <small>Message</small>
                                    <textarea className="form-control"></textarea>
                                </div>
                                <div className="form-group">
                                    <input type="button" className="form-control messagebtn" value="Submit"/>
                                </div>
                            </div>
                        </div>
                   </div>}
                </div>
            </div>
        ) 
    }
}

export default (Message);



// WEBPACK FOOTER //
// ./src/components/Toolkit/Message/Message.jsx